;(function() {
  let tooltipButton = [].slice.call(
    document.body.querySelectorAll(
      'button[data-tooltip-toggle], a[data-tooltip-toggle]'
    )
  )

  let tooltipContent = [].slice.call(
    document.body.querySelectorAll('[data-tooltip-content]')
  )

  let showTooltipContent = false

  tooltipButton.forEach(toggleButton => {
    toggleButton.addEventListener('click', () => {
      tooltipContent.forEach(toggleContent => {
        if (!toggleContent.classList.contains('+display-none')) {
          toggleContent.classList.add('+display-none')
        }
      })

      showTooltipContent = !showTooltipContent
      let contentBox = toggleButton.nextElementSibling

      showTooltipContent
        ? contentBox.classList.remove('+display-none')
        : contentBox.classList.add('+display-none')
    })
  })
})()
